import React, { useState } from 'react';
import { FormGroup } from 'reactstrap';
import { MobileComponent, DesktopComponent } from '../../components/Responsive';
import format from 'date-fns/format';
import { Validators, FormSubmitButton } from '@dom/components';
import { useFormValidator } from '@sharingapples/form';

import { useSelector } from '../../redux';
import { getGuideSearchQuery,  } from '../../redux/selectors';
 
import {
  GuidePax,
  GuideBookingDates,
  GuideSearchInput,
} from '../../components/GuideSearchFormElements';

import './guideSearchModify.scss';

const DATE_FORMAT= 'ddd, MMM DD';

const noInputText = () => '';

export default function GuideSearchModify() {

  const [isFormMinimized, setIsFormMinimized] = useState(true);
  const minimizeForm = () => setIsFormMinimized(true);
  const expandForm = () => setIsFormMinimized(false);
  
  const { guideQuery, startDate, endDate, pax } = useSelector(getGuideSearchQuery) || {};

  const bookingDatesError = useFormValidator('startDate', Validators.required('Please inform us your booking dates.'));

  // When Form is sumbitted from Porter-Guide Card
  // Expand the Form to show errors if any.
  if (isFormMinimized && bookingDatesError) expandForm();

  const SearchModifyForm = ({ onUpdate }) => (
    <>
    {/* <h4>Search</h4> */}
    <section className="SearchForm modify">
      <GuideSearchInput label="Trek" wrap autoFocus={false} tabIndex={1} validator={Validators.required('Which Trek/Hike are you doing?')}/>
      <GuideBookingDates aria-label="Trek start date" label="Start - End Dates" parentError={bookingDatesError} />
      <GuidePax label="Number of Trekkers" getInputText={noInputText}/>
      <FormGroup>
        <FormSubmitButton buttonText="Modify" onSubmit={minimizeForm}/>
      </FormGroup>
    </section>
    </>
  );

  const MinimizedSearchModifyForm = ({ onClick }) => (
    <section className="side__panel d-xl-none" onClick={onClick}>
      <div className="side__panel_res ">
        <div className="search_info">
          <i className="icon icon-hg-search"></i>
          <span style={{ marginLeft: '5px' }}>{guideQuery ? guideQuery : 'Which Trek/Hike are you doing?'}</span>
        </div>
        <div className="search_info">
          <span>
            <i className="icon icon-hg-calendar"></i>{' '}
            {startDate && endDate ? `${format(startDate, DATE_FORMAT)} - ${format(endDate, DATE_FORMAT)}`:  'Select Start And End Dates.'}
          </span>
          <span><i className="icon icon-hg-user"></i>{' '}{pax > 1 ? `${pax} Trekkers` : '1 Trekker'}</span>
        </div>
      </div>
    </section>
  );


  return (
    <>
    <MobileComponent>
      {isFormMinimized ? <MinimizedSearchModifyForm onClick={expandForm} /> : <SearchModifyForm />}
    </MobileComponent>
    <DesktopComponent>
      <SearchModifyForm/>
    </DesktopComponent>
    </>
  );
}
